<template>
  <div class="container-wrapper">
    <div class="content">
      <div class="wrapper">
        <h1 class="button" style="text-align: center; padding-top: 5px"><a href="/brackets" class="bracket-link" target="_blank">Brackets!</a></h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

    .container-wrapper{
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 90px 20px;
        background: #012A2D;
        @media only screen and (max-width:780px) {
            padding: 50px 10px;
        }

        .heading{
            margin-bottom: 80px;
            @media only screen and (max-width:980px) {
                margin-bottom: 40px;
                width: 280px;
            }
            @media only screen and (max-width:780px) {
                margin-bottom: 30px;
                width: 200px;
            }
        }
        .content{
            display: flex;
            align-items: flex-start;
            justify-content: center;
            &>*:not(:last-child){
                margin-right: 150px;
                @media only screen and (max-width:1140px) {
                    margin-right: 50px;
                }
                @media only screen and (max-width:580px) {
                    margin-right: 20px;
                }
            }
            .wrapper{
                .thumbnail{
                    width: 250px;
                    margin-bottom: 28px;
                    clip-path: polygon(50% 0%, 100% 20%, 100% 75%, 50% 100%, 0 75%, 0 20%);
                    @media only screen and (max-width:980px) {
                        width: 180px;
                    }
                    @media only screen and (max-width:780px) {
                        margin-bottom: 18px;
                        width: 120px;
                    }
                    @media only screen and (max-width:780px) {
                        margin-bottom: 15px;
                        width: 80px;
                    }
                }
                .title{
                    font-family: 'Lato';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 24px;
                    line-height: 29px;
                    text-align: center;
                    color: #FFFFFF;
                    text-transform: capitalize;
                    @media only screen and (max-width:980px) {
                        font-size: 20px;
                    }
                    @media only screen and (max-width:780px) {
                        font-size: 14px;
                        line-height: 18px;
                    }


                }
                .button{
                   width: 308px;
                   height: 44px;
                   background: #EE2A7B;
                   border: none;
                   transition: all .2s;
                   cursor: pointer;
                   font-weight: 700;
                   font-size: 24px;
                   line-height: 29px;
                   color: #012A2D;
                   margin-bottom: 40px;
                   @media only screen and (max-width:740px){
                     width: 270px;
                   }
                   &:active{
                     transform: scale(0.95);
                   }
                   &:hover{
                     box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.05);
                   }
                }

            }
        }

    }

</style>